import React, {useState, useEffect} from 'react'
import styled from 'styled-components';
import LeftIcon from '../../icons/tableIcons/LeftIcon';
import RightIcon from '../../icons/tableIcons/RightIcon';

const PaginationContainer = styled.div`
    display: flex;
`
const PaginationLinks = styled.a`
    color: white;
    margin-left: 7px;
    background-color:black;
    width:25px;
    height:25px;
    text-align: center;
    justify-content:center;
    border-radius: 10px;
    padding: 0;
    cursor:pointer;

    &:hover {
        background-color: #40a9ff;
    }


`
const MovePrevLinks = styled.a`
    color: white;
    margin-left: 7px;
    background-color: ${(props) =>props.setColor};
    width:25px;
    height:25px;
    text-align: center;
    justify-content:center;
    border-radius: 10px;
    padding: 0;
    cursor: pointer;


`
const MoveNextLinks = styled.a`
    color: white;
    margin-left: 7px;
    background-color: ${(props) =>props.setColor};
    width:25px;
    height:25px;
    text-align: center;
    justify-content:center;
    border-radius: 10px;
    padding: 0;


`

const Pagination = ({
    postsPerPage, 
    totalPosts, 
    paginate, 
    prevpage, 
    nextpage, 
    currentPage }) => {

    const pageNumbers = [];

  for(let i= 1; i <= Math.ceil(totalPosts / postsPerPage); i++){
      pageNumbers.push(i)
  }

  const [prevButtonColor, setPrevButtonColor] = useState('black');
  const [nextButtonColor, setNextButtonColor] = useState('black');

  const prevButtonChangeColor = () =>{
        if(currentPage === 1){
        setPrevButtonColor('#595959')
    } else{
        setPrevButtonColor('black')
    }
    }

  const nextButtonChangeColor = () => {
        if(currentPage === pageNumbers.length){
          setNextButtonColor('#595959')
        } else{
          setNextButtonColor('black')
        }
    }

    useEffect(() => {
        prevButtonChangeColor()
        nextButtonChangeColor()
    });


  return (
    <>
        <PaginationContainer>
            <MovePrevLinks setColor={prevButtonColor} onClick ={prevpage}><LeftIcon/></MovePrevLinks>
            <PaginationLinks onClick ={() => paginate(1)} >1</PaginationLinks>
            <PaginationLinks onClick ={() => paginate(2)} >2</PaginationLinks>
            <PaginationLinks onClick ={() => paginate(3)} >3</PaginationLinks>
            <MoveNextLinks setColor={nextButtonColor} onClick ={() => nextpage(pageNumbers.length) }><RightIcon/></MoveNextLinks>
        </PaginationContainer>
    </>
  )
}

export default Pagination